<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>電話帳作成</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>電話帳名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="10" v-model="contactName" class="form-control" autocomplete="off" placeholder="電話帳名" required>
              </div>
            </div>
          </div>
            <div class="form-group">
              <div class="row">
                <div class="col-4">
                  <label>連絡先グループの階層利用</label>
                </div>
                <div class="col-4">
                  <input name="isHierarchyGroupEnabled" id="hierarchyOn" type="radio" value="true" v-model="isHierarchyGroupEnabled" required>
                  <label for="hierarchyOn" class="radio-label">利用する</label>
                </div>
                <div class="col-4">
                  <input name="isHierarchyGroupEnabled" id="hierarchyOff" type="radio" value="false" v-model="isHierarchyGroupEnabled" required>
                  <label for="hierarchyOff" class="radio-label">利用しない</label>
                </div>
              </div>
            </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'ExtraCreate',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      name: 'extraContact',
      message: '',
      contactName: '',
      isHierarchyGroupEnabled: false
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.post("/api/extracontact", {
              contactName: this.contactName,
              hospitalId: hospitalId,
              isHierarchyGroupEnabled: this.isHierarchyGroupEnabled
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>